import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import type {AxiosError} from "axios"

import axios from "../../utils/axios"
import AdvertsApi from "../../config/api/adverts"
import {AdvertsContent} from "../../models/SearchState"

const advertsApi = AdvertsApi("getAdsConfig")

// this will always be called server-side on first render and subsequent server-side renders
export const getAdsConfig = async ({
    headers,
    urlPath,
}: {
    headers: IncomingHttpHeaders
    urlPath: string
}): Promise<{content: AdvertsContent[]}> => {
    try {
        const response = await axios({
            method: advertsApi.method,
            url: advertsApi.localEndpoint(),
            headers: headers as {
                [header: string]: string
            },
            params: {
                urlPath,
            },
        })
        return response.data
    } catch (err) {
        const error = err as AxiosError
        logger.error(error)
        return {content: []}
    }
}
